document.addEventListener('DOMContentLoaded', function() {
  const toggleBtn = document.getElementById('mpopupToggle');
  const closeBtn = document.getElementById('mpopupCloseBtn');
  const popup = document.getElementById('msizeChartPopup');
  const popupContainer = document.querySelector('.msizePopup-container');

  function disableBodyScroll() {
    document.body.style.overflow = 'hidden';
  }

  function enableBodyScroll() {
    document.body.style.overflow = '';
  }

  toggleBtn.addEventListener('click', function() {
    popup.classList.add('mpopupActive');
    disableBodyScroll();
  });

  closeBtn.addEventListener('click', function() {
    popup.classList.remove('mpopupActive');
    enableBodyScroll();
  });

  popup.addEventListener('click', function(event) {
    if (!popupContainer.contains(event.target)) {
      popup.classList.remove('mpopupActive');
      enableBodyScroll();
    }
  });
});
